export default __webpack_public_path__ + "static/weibo-f1fba1b8753d2f3155969133b4647637.png";